export default "__VITE_ASSET__cecbf3eb__"